import React, { useState } from 'react';
import {
    AttachDocumentsFormItem,
    AttachDocumentsFormItemInfo,
    AttachDocumentsFormItemTitle,
    AttachDocumentsFormItemParagraph,
    AttachDocumentsLoaderContainer,
    AttachDocumentsLoader,
    AttachDocumentButton,
    AttachDocumentLabelFile
} from '../styles';
import {
    UploadFileButton,
} from '../../../components/Buttons/styles';
import { uploadFileOnBase } from '../../../services/documentsBpm';
import { P } from '../../../components/Typography/styles';
import colors from '../../../assets/styles/colors';
import { FiArrowUp, FiCheck } from 'react-icons/fi';
import { RiCloseFill } from 'react-icons/ri';
import { toBase64 } from '../../../helpers/base64';
import ModalInfo from '../../../components/ModalInfo';
import { BsExclamation } from 'react-icons/bs';
import Loader from '../../../components/Loader';
import eliminar from '../../../assets/images/eliminarIcono.png'
import { ParagraphDelete } from '../styles';


const AttachDocumentsItem = ({ title, paragraph, key, inputlabel, credito, files,onFileChange,alerta }) => {
    const [file, setFile] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState('');
    const [showModalInfoError, setShowModalInfoError] = useState(false);
    const [titleErrorOnFile, setTitleErrorOnFile] = useState('');
    const [messageErrorOnFile, setMessageErrorOnFile] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmitFile = async (e) => {
        setIsLoading(true);
        const maxSize = 10 * 1024 * 1024;
        const file = e.target.files[0];
        try {
            if (file && file.size > maxSize) {
                e.target.value = '';
                setMessageErrorOnFile('Tamaño máximo permitido: 10MB.');
                setShowModalInfoError(true);
                handleDeleteFile();
            } else {
                onFileChange(inputlabel, file,true,alerta);
                setFile(file);
                setIsLoaded(true);
                setIsLoading(false);
                if(file.type != 'application/pdf'){
                    setMessageErrorOnFile('Solo se pueden cargar archivos de tipo pdf');
                    setShowModalInfoError(true);
                    handleDeleteFile();
                }
            }
        } catch (e) {
            console.log(e);
            setFile(null);
            setError('Error al subir el archivo, reintentar');
        }
    }

    function resetFileInput() {
        const fileInput = document.getElementById(inputlabel);
        fileInput.value = null;
    }

    function modalErrorResetDefault() {
        setShowModalInfoError(false)
        setMessageErrorOnFile('');
        setTitleErrorOnFile('');
    }

    const handleDeleteFile = () => {
        setFile(null);
        onFileChange(inputlabel, null , false);
        setIsLoaded(false);
        resetFileInput();
    }

    return (
        <AttachDocumentsFormItem key={key}>
            <AttachDocumentsFormItemInfo>
                <AttachDocumentsFormItemTitle color={colors.textPrimary}>{title}</AttachDocumentsFormItemTitle>
                <AttachDocumentsFormItemParagraph color={colors.textPrimary}>{paragraph}</AttachDocumentsFormItemParagraph>
                <AttachDocumentsLoaderContainer>
                    <AttachDocumentsLoader percentage={file ? 100 : 0} />
                </AttachDocumentsLoaderContainer>
            </AttachDocumentsFormItemInfo>
            <AttachDocumentButton>
                <UploadFileButton uploaded={file}>
                    <label htmlFor={file ? '' : inputlabel} style={{ width: '100%', height: '100%', cursor: 'pointer' }}>
                        {isLoaded ? <FiCheck size={26} color={colors.white} /> : <FiArrowUp size={25} color={colors.textPrimary} />}
                    </label>
                </UploadFileButton>
            </AttachDocumentButton>
            <AttachDocumentLabelFile>
                {isLoaded ? <>{/*<RiCloseFill size={25} color={colors.bgDanger} style={{ cursor: 'pointer' }} onClick={handleDeleteFile} />*/}<ParagraphDelete color={colors.textPrimary} bold >{file?.name}</ParagraphDelete><img height={25} src={eliminar} style={{ cursor: 'pointer', marginLeft: '200px' }} onClick={handleDeleteFile}></img> </> : ''}
            </AttachDocumentLabelFile>
            <input type="file" accept='application/pdf' id={inputlabel} name={inputlabel} style={{ display: 'none' }}
                onChange={handleSubmitFile}
            />
            {isLoading && <Loader />}
            <ModalInfo
                open={showModalInfoError}
                setShowModal={modalErrorResetDefault}
                title={titleErrorOnFile}
                description={messageErrorOnFile}
                backgroundIcon={colors.bgDanger}
                bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
        </AttachDocumentsFormItem>
    )
}

export default AttachDocumentsItem;

